/* @flow */

import React from 'react';
import DiffusionSecurity from './plugins/security/diffusion/DiffusionSecurity';

const replaceDotBySlash = (template: CatalogTemplate) =>
  template.replace('.', '/');

const usingPlugin = (template: CatalogTemplate) => (
  execute: Object => void,
  defaultValue: Object = null
) => {
  try {
    const plugin = require(`./plugins/${replaceDotBySlash(template)}/index.js`);
    return execute(plugin);
  } catch (error) {
    console.warn(`No plugin found for template ${template}`, error);
    return defaultValue;
  }
};

export const writeContent = (
  template: CatalogTemplate,
  content: CatalogPageContent
) => {
  return usingPlugin(template)(plugin => {
    if (plugin.writeContent) {
      return plugin.writeContent(content);
    }

    return content;
  }, content);
};

export const getContentWarnings = (
  template: CatalogTemplate,
  content: ?CatalogPageContent
): Array<String> => {
  return usingPlugin(template)(plugin => {
    if (content && plugin.getContentWarnings) {
      return plugin.getContentWarnings(content);
    }

    return [];
  }, []);
};

export const getEditComponent = (
  template: CatalogTemplate,
  content: CatalogPageContent
) => {
  return usingPlugin(template)(plugin => {
    const component = plugin.getEditComponent();
    return React.createElement(component, {
      content,
    });
  });
};

export const getViewComponent = (
  template: CatalogTemplate,
  content: CatalogPageContent
) => {
  return usingPlugin(template)(plugin => {
    const component = plugin.getViewComponent();
    return React.createElement(component, {
      content,
    });
  });
};

export const getSecurityComponent = (page: CatalogPage) => {
  return <DiffusionSecurity security={page.security} />;
};

export const isPageSecured = page => {
  return page.security.targets && page.security.targets.length > 0;
};



// WEBPACK FOOTER //
// ./src/modules/catalog/plugin.js